import { useEffect, useState } from 'react';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, Typography, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import { navForRole } from '../components/officerNav';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

// Tenders whose bids have been opened are ready for evaluation.
export default function EvaluationList() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [tenders, setTenders] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    (async () => {
      let rows;
      if (user?.role === 'EVALUATOR') {
        const { data } = await api.get('/evaluation/my-tenders');
        rows = data.data;
      } else {
        const { data } = await api.get('/tenders', { params: { pageSize: 100 } });
        rows = data.data;
      }
      // Evaluation can only start once bids have been opened - filter the
      // list to that evaluatable state (matches the requireOpened guard
      // enforced server-side when the workspace itself is opened).
      setTenders((rows || []).filter((t) => !!t.bidsOpenedAt));
      setLoaded(true);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <DashboardLayout nav={navForRole(user?.role)} welcomeName={user?.fullName} title="Evaluation Workspace">
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select a tender whose bids have been opened to evaluate technical and financial proposals.
      </Typography>
      <Paper>
        <Table>
          <TableHead><TableRow>
            <TableCell>Reference</TableCell><TableCell>Title</TableCell><TableCell>Status</TableCell><TableCell align="right">Action</TableCell>
          </TableRow></TableHead>
          <TableBody>
            {tenders.map((t) => (
              <TableRow key={t.id} hover>
                <TableCell>{t.reference}</TableCell>
                <TableCell>{t.title}</TableCell>
                <TableCell><Chip size="small" label={t.status} /></TableCell>
                <TableCell align="right"><Button size="small" onClick={() => navigate(`/officer/evaluation/${t.id}`)}>Evaluate</Button></TableCell>
              </TableRow>
            ))}
            {loaded && tenders.length === 0 && (
              <TableRow><TableCell colSpan={4}>
                <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
                  {user?.role === 'EVALUATOR'
                    ? 'No tenders assigned to you have had bids opened yet.'
                    : 'No tenders available. Bids must be opened before evaluation can begin.'}
                </Typography>
              </TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </DashboardLayout>
  );
}
